import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { noop } from '../../../../../utils/utils';

class ModifyCampaignTargetButton extends React.Component {
  static propTypes = {
    onClick: PropTypes.func,
  };

  static defaultProps = {
    onClick: noop,
  };

  render() {
    return (
      <Button
        id="modifyTargetButton"
        color="primary"
        type="button"
        variant="outlined"
        onClick={this.props.onClick}>
        Modify Target
      </Button>
    );
  }
}

export default ModifyCampaignTargetButton;
